import { render } from "./Cohort.vue?vue&type=template&id=9489d21a"
import script from "./Cohort.js?vue&type=script&lang=js"
export * from "./Cohort.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__